import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { PayoutRes } from 'features/payouts/types/payouts.types'
import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'

const MAX_RETRIES = 3

export const useFetchPayout = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const { auth } = useContext(AuthContext)

	const { data: payout, error } = useQuery<PayoutRes>({
		queryKey: queryKeys.payouts.detail(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.payout(params.id as string)),
		enabled: !!auth.accessToken,
		retry: (failureCount, err: any) => err?.response?.status !== 404 && failureCount < MAX_RETRIES
	})

	return {
		payout,
		isPayoutNotFound: (error as any)?.response?.status === 404
	}
}
